import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Movie } from 'app/shared/models/class/movie/movie';
import { Rating } from 'app/shared/models/class/rating/rating';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MovieService {
  constructor(private http: HttpClient) {}

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getMovies(filter: boolean): Observable<Movie[]> {
    let params = new HttpParams();
    params = params.append('filter', filter);
    return this.http.get<Movie[]>(`${environment.apiUrl}Movie/admin`, {
      params,
    });
  }

  getMovie(id: string): Observable<Movie[]> {
    let params = new HttpParams();
    params = params.append('id', id);
    

    return this.http.get<Movie[]>(`${environment.apiUrl}Movie/admin`, {
      params,
    });
  }
}
